<template>
  <div class="coupons-item">
    <div>序号{{ index + 1 }}</div>
    <div class="goods-details-box">
      <p>奖品类型<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>EC优惠券</p>
      <div style="display: flex;align-items: center;width: 100%;gap: 10px;">
        <p><span class="required-point">*</span>奖品名称</p>
        <el-input v-model="item.name" :disabled="handleType == 'preview'" placeholder="输入标题文案，最长输入7个汉字" style="width: 360px;" />
      </div>
      <div style="display: flex;align-items: center;width: 100%;gap: 10px;">
        <p><span class="required-point">*</span>奖品数量</p>
        <el-input v-model="item.stock" :disabled="handleType == 'preview'" type="number" placeholder="请输入奖品数量" style="width: 156px;" />
      </div>
      <div style="display: flex;align-items: center;width: 100%;gap: 10px;">
        <p><span class="required-point">*</span>中奖概率</p>
        <el-input v-model="item.odds" :disabled="handleType == 'preview'" type="number" placeholder="请输入中奖概率" style="width: 156px;" />
        <span>%</span>
      </div>
      <div style="display: flex;align-items: center;width: 100%;gap: 10px;">
        <p><span class="required-point">*</span>跳转路径</p>
        <el-input v-model="item.thirdRel" :disabled="handleType == 'preview'" placeholder="请输入跳转路径" style="width: 360px;" />
      </div>
    </div>
    <div v-if="handleType !='preview'" class="handle-box">
      <template v-if="item.name || item.stock || item.odds || item.thirdRel">
        <el-button type="info" size="small" @click="handleAward('reset')">重置</el-button>
      </template>
      <template v-if="item.name && item.stock && item.odds && item.thirdRel">
        <el-button type="primary" size="small" @click="handleAward('save')">保存</el-button>
      </template>
      <el-button type="danger" size="small" @click="handleAward('del')">删除</el-button>
    </div>
  </div>
</template>

<script>

export default {
  name: 'CouponsAward',
  components: { },
  props: {
    index: {
      type: Number,
      default: 0,
    },
    item: {
      type: Object,
      default: () => ({}),
    },
    handleType: {
      type: String,
      default: '',
    },
  },
  data() {
    return {

    };
  },
  watch: {
    'item.name': {
      handler(newVal) {
        const maxlen = 14;
        if (this.byteLen(newVal) > maxlen) {
          this.item.name = this.getMaxlen(newVal, maxlen);
        }
      },
    },
  },
  methods: {
    handleAward(e) {
      this.$emit('handleAward', { index: this.index, item: this.item, type: e });
    },
    byteLen (str) {
      str += '';
      var tmp = str.match(/[^\x00-\xff]/g) || [];
      return str.length + tmp.length;
    },
    getMaxlen(str, maxlen) {
      var sResult = ''; var L = 0; var i = 0; var stop = false; var sChar;
      if (str.replace(/[^\x00-\xff]/g, 'xxx').length <= maxlen) {
        return str;
      }
      while (!stop) {
        sChar = str.charAt(i);
        L += sChar.match(/[^\x00-\xff]/) !== null ? 2 : 1;
        if (L > maxlen) {
          stop = true;
        } else {
          sResult += sChar;
          i++;
        }
      }
      return sResult;
    },
  },
};
</script>

<style lang="less" scoped>
.coupons-item{
  display: flex;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  min-height: 246px;
  background: #F7F7F7;
  padding: 36px 50px;
  margin-bottom: 30px;
  gap: 86px;
}
.goods-details-box{
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  justify-items: center;
  height: 100%;
  gap: 16px;
  font-size: 14px;
  color: #494949;
}
.required-point{
  color: #FF4D4F;
  margin-right: 2px;
}
.handle-box{
  display: flex;
  align-items: center;
}
</style>
